export const forum = {
  breadcrumb: {
    root: 'Forum',
    self: 'Mijn posts',
    saved: 'Opgeslagen posts',
    guidelines: 'Richtlijnen',
  },
  alerts: {
    createComment: {
      error: 'Er is iets misgelopen bij het aanmaken van je reactie.',
      success: 'Je reactie werd succesvol aangemaakt.',
    },
    createPost: {
      error: 'Er is iets misgelopen bij het aanmaken van je post.',
      success: 'Je post werd succesvol aangemaakt.',
    },
    deleteComment: {
      error: 'Er is iets misgelopen bij het verwijderen van je reactie.',
      success: 'Je reactie werd succesvol verwijderd.',
    },
    deletePost: {
      error: 'Er is iets misgelopen bij het verwijderen van je post.',
      success: 'Je post werd succesvol verwijderd.',
    },
    editComment: {
      error: 'Er is iets misgelopen bij het bewerken van je reactie.',
      success: 'Je reactie werd succesvol bewerkt.',
    },
    editPost: {
      error: 'Er is iets misgelopen bij het bewerken van je post.',
      success: 'Je post werd succesvol bewerkt.',
    },
  },
  comments: {
    communityProfileRequired: {
      action: 'Profiel openbaar zetten',
      description: 'Om te reageren heb je een openbaar community-profiel nodig.',
    },
    error: {
      title: 'Fout bij het laden van de reacties',
    },
    titleUnknown: 'Reacties',
    title_one: '{{count}} reactie',
    title_other: '{{count}} reacties',
  },
  createComment: {
    actions: {
      comment: 'Reageer',
    },
  },
  createPost: {
    actions: {
      post: 'Plaatsen',
    },
    disclaimer: 'Lees eerst de <guidelinesLink>Community richtlijnen</guidelinesLink> voordat je post.',
    fields: {
      content: {
        label: 'Inhoud',
      },
      tag: {
        description: 'Kies de tag die het best bij je post past.',
        label: 'Tag',
      },
      title: {
        label: 'Titel',
      },
    },
    title: 'Post maken',
  },
  deleteComment: {
    actions: {
      confirm: 'Verwijder comment',
    },
    description: 'Ben je zeker dat je jouw comment wilt verwijderen?',
    title: 'Comment verwijderen?',
  },
  deletePost: {
    actions: {
      confirm: 'Verwijder post',
      confirmUnable: 'Begrepen',
    },
    description: 'Ben je zeker dat je jouw post "{{title}}" wilt verwijderen?',
    descriptionUnable:
      'Je kan jouw post niet verwijderen, omdat andere freelancers erop gereageerd hebben.<br/>Wil je ze toch graag verwijderen? Neem dan contact op met <emailLink href="mailto:community@creativeshelter.be">community@creativeshelter.be</emailLink>.',
    title: 'Post verwijderen?',
    titleUnable: 'Verwijderen niet mogelijk',
  },
  guidelines: {
    content:
      '<introduction>De community spelregels. Niet omdat het een spel is dat je kan uitspelen, maar misschien wel iemand schaakmat zetten met een terechte opmerking. Maar dan lief, ingepakt met watten en bubblewrap hé.</introduction>\n\n<subtitle>Lief zijn hé. Willen we dat afspreken?</subtitle>\n\n<paragraph>Het forum kwam er voor jou en alle andere Shelteraars, maar wij houden mee een oogje in ‘t zeil. Grof taalgebruik, racistische opmerkingen, homofoob gedrag … daar is geen plaats voor.</paragraph>\n\n<paragraph>Lief zijn voor elkaar is de boodschap.</paragraph>\n\n<subtitle>Er zijn geen domme vragen of antwoorden</subtitle>\n\n<paragraph>Alle Shelteraars kunnen reageren, advies geven of hun mening delen bij gestelde vragen in het forum. ‘t Kan dus zijn dat je niet met alles akkoord bent of dat er eens een foutje in een antwoord sluipt. Ook daar geldt: wees lief voor elkaar. Of zoals K3 het zou zeggen: verdraagzaam zijn!</paragraph>\n\n<paragraph>Een juridische vraag, tips over de boekhouding of auteursrechten? Dan kan het weleens zijn dat Creative Shelter zelf reageert.</paragraph>\n\n<subtitle>Gevoelige informatie? Die blijft binnen de community muren.<br />What happens at the forum, stays at the forum.</subtitle>\n\n<paragraph>Gevoelige situaties, uurtarieven, het adres van iemands oma … vertel je niet verder. Het forum is net de plek om in een veilige omgeving over zo’n topics te babbelen en te sparren, zonder dat het opeens de ronde gaat. Om te roddelen moet je in je groepschat met de vrienden zijn.</paragraph>',
    header: {
      title: 'Community richtlijnen',
    },
  },
  moderatorDialog: {
    introduction:
      'Ik hou het hier netjes, gezellig en een beetje op koers. Spreek mij gerust aan voor vragen of complimenten: ik hoor het allemaal graag.',
  },
  overview: {
    error: {
      title: 'Fout bij het laden van het forum',
    },
    header: {
      title: 'Community forum',
    },
    postPreview: {
      pinned: 'Vastgezet',
    },
    savedPosts: {
      empty: 'Je hebt geen opgeslagen posts.',
      error: {
        title: 'Fout bij het laden van jouw opgeslagen posts',
      },
      title: 'Opgeslagen posts',
    },
    selfPosts: {
      empty: 'Je hebt nog geen posts gemaakt.',
      error: {
        title: 'Fout bij het laden van jouw posts',
      },
      title: 'Mijn posts',
    },
    timeline: {
      empty: 'Hier werd nog niks gepost.',
      error: {
        title: 'Fout bij het laden van jouw startpagina',
      },
      title: 'Startpagina',
    },
  },
  post: {
    card: {
      actions: {
        comment: 'Reageer',
        like: 'Vind ik leuk ({{count}} likes)',
        comments: '{{count}} reacties',
      },
      edited: 'bewerkt',
    },
    error: {
      title: 'Fout bij het laden van de post',
    },
    systemMessages: {
      CommentDeletedByModerator:
        '{{moderator, ucfirst}} heeft deze comment verwijderd omdat deze niet voldoet aan onze <guidelinesLink>richtlijnen</guidelinesLink>.',
      CommentDeletedByUser: 'Deze comment werd verwijderd.',
      LockedByModerator: '{{moderator, ucfirst}} heeft deze post vergrendeld. Reageren is niet meer mogelijk.',
      MovedByModerator: '{{moderator, ucfirst}} heeft deze post verplaatst van <bold>{{oldTag}}</bold> naar <bold>{{newTag}}</bold>.',
      unknownModerator: 'een moderator',
    },
  },
  sidebar: {
    sections: {
      favoriteTags: 'Favoriete tags',
      quickLinks: 'Handige links',
      tags: 'Alle tags',
    },
    toggleFavoriteTag: 'Markeer {{tag}} als favoriet',
  },
  tags: {
    Announcements: {
      name: 'Aankondigingen',
    },
    Audiovisual: {
      name: 'Audiovisueel',
    },
    DigitalDesign: {
      name: 'Digitaal ontwerp',
    },
    FreelanceLife: {
      name: 'Freelance leven',
    },
    ItDevelopment: {
      name: 'IT-ontwikkeling',
    },
    LanguageAndCommunication: {
      name: 'Taal en communicatie',
    },
    OnlineContentCreation: {
      name: 'Online contentcreatie en storytelling',
    },
    PerformingArtists: {
      name: 'Uitvoerende kunstenaar',
    },
    Photography: {
      name: 'Fotografie',
    },
    VisualCommunication: {
      name: 'Visuele communicatie',
    },
  },
};
